import { useTranslation } from 'react-i18next'
import type { KeyValue } from './masterData.types'

/** Übersetzt label (fields.*) und value (values.*, nur wenn Key existiert); hängt Einheit (units.*) an. */
export function MasterDataRow({ row }: { row: KeyValue }) {
  const { t } = useTranslation()
  const valueKey = `productMasterData.values.${row.value}`
  const translatedValue = t(valueKey)
  const value = translatedValue === valueKey ? row.value : translatedValue
  const unit = row.unit ? ` ${t(`productMasterData.units.${row.unit}`)}` : ''
  return (
    <div className="flex justify-between gap-3 py-1.5 text-sm border-b border-neutral-100 dark:border-neutral-800 last:border-0">
      <dt className="text-neutral-500 dark:text-neutral-400">{t(`productMasterData.fields.${row.label}`)}</dt>
      <dd className="font-medium text-right tabular-nums text-neutral-900 dark:text-neutral-100">{value}{unit}</dd>
    </div>
  )
}
